export var setOfferFilter = new Set([
    "growingGoldPOs1999",
    "growingDollarPOs0999",
    "growingDollar50POs2999",
    "growingDollar50POs4999",
    "growingMixedSeaweed30POs1999",
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/setOfferFilter.ts
// module id = 2012
// module chunks = 3